import {
  axiosPost,
  axiosGet,
  axiosDelete,
  axiosPut,
} from '../../plugins/axios.plugins';
import { getDataApiVersion } from '../../utils/helpers';
const API_ENDPOINTS = {
  DATA_API: `${process.env.VUE_APP_DATA_API}`,
  DATA_API_BASE_URL: `${process.env.VUE_APP_DATA_API_BASE_URL}`,
};

export const getWorkFlowById = (workFlowId) => {
  return axiosGet(`${API_ENDPOINTS.DATA_API}/get-flow/${workFlowId}`);
};

export const getSharedWorkFlowUsers = (workFlowId) => {
  return axiosGet(`${API_ENDPOINTS.DATA_API}/flow/iam/${workFlowId}`);
};

export const deleteWorkFlowById = (workFlowId) => {
  return axiosDelete(`${API_ENDPOINTS.DATA_API}/flow/${workFlowId}`);
};

export const getDataBaseTableSchema = (
  dbName,
  customNotFoundRedirect = false
) => {
  return axiosGet(
    `${API_ENDPOINTS.DATA_API}/user-tables/${dbName}/table-schema`,
    customNotFoundRedirect ? { customNotFoundRedirect } : {}
  );
};

export const getCustomDatabaseItem = (
  tableName,
  itemID,
  customNotFoundRedirect = false
) => {
  return axiosGet(
    `${API_ENDPOINTS.DATA_API_BASE_URL}/${getDataApiVersion(
      tableName
    )}/user-tables/${tableName}/items/${itemID}`,
    customNotFoundRedirect ? { customNotFoundRedirect } : {}
  );
};

export const getCustomDatabaseItems = (
  tableName,
  params = '',
  customNotFoundRedirect = false
) => {
  return axiosGet(
    encodeURI(
      `${API_ENDPOINTS.DATA_API_BASE_URL}/${getDataApiVersion(
        tableName
      )}/user-tables/${tableName}/items${params}`
    ),
    customNotFoundRedirect ? { customNotFoundRedirect } : {}
  );
};

export const duplicateDatabaseItems = (tableName, itemId) => {
  return axiosPut(
    `${API_ENDPOINTS.DATA_API_BASE_URL}/${getDataApiVersion(
      tableName
    )}/user-tables/${tableName}/items/${itemId}/duplicate`
  );
};

export const getFlowPublicAccess = (flowId) => {
  return axiosGet(`${API_ENDPOINTS.DATA_API}/flow/${flowId}/public-access`);
};

export const deleteWorkflowPolicy = (payload) => {
  return axiosDelete(`${API_ENDPOINTS.DATA_API}/flow/share`, payload);
};
export const getUserDataByID = (userID, key) => {
  return axiosGet(`${API_ENDPOINTS.DATA_API}/users/${userID}/${key}`);
};

// type 'table' or 'workflow'
export const getLogs = (id, type = 'table') => {
  return axiosGet(
    encodeURI(
      `${API_ENDPOINTS.DATA_API}/logs/${encodeURIComponent(id)}?type=${type}`
    )
  );
};

export const putUserLoginDetails = (params = '', payload = {}) => {
  return axiosPost(`${API_ENDPOINTS.DATA_API}/log-user-login`, payload);
};

export const deleteTablePolicy = (databaseName, payload = {}) => {
  return axiosDelete(
    `${API_ENDPOINTS.DATA_API}/user-tables/${databaseName}/share`,
    payload
  );
};

export const getWorkFlowAttribute = (workFlowId, attribute) => {
  return axiosGet(
    `${API_ENDPOINTS.DATA_API}/flow/${workFlowId}/key/${attribute}`
  );
};
export const getWorkFlowTags = () => {
  return axiosGet(`${API_ENDPOINTS.DATA_API}/tags`);
};

export const createWorkFlowTags = (payload) => {
  return axiosPost(`${API_ENDPOINTS.DATA_API}/tags`, payload);
};
export const editWorkFlowTags = (tagID, params = '') => {
  return axiosPut(`${API_ENDPOINTS.DATA_API}/tags/${tagID}?${params}`);
};

export const deleteTags = (tagID, params = '') => {
  return axiosDelete(`${API_ENDPOINTS.DATA_API}/tags/${tagID}${params}`);
};

export const createLoadProfileThumbnail = (
  loadID,
  customNotFoundRedirect = true
) => {
  return axiosPut(
    encodeURI(
      `${API_ENDPOINTS.DATA_API}/loadprofile/${encodeURIComponent(
        loadID
      )}/thumbnail`
    ),
    {},
    customNotFoundRedirect ? { customNotFoundRedirect } : {}
  );
};

export const updatePolicy = (policyId, payload) => {
  return axiosPut(`${API_ENDPOINTS.DATA_API}/policy/${policyId}`, payload);
};

export const getFlowsList = () => {
  return axiosGet(`${API_ENDPOINTS.DATA_API}/flow-list`);
};
export const getCodeTaskLogs = (workflowId, taskId) => {
  return axiosGet(
    `${API_ENDPOINTS.DATA_API}/code-logs?flow-id=${workflowId}&task-id=${taskId}`
  );
};

export const createDatabaseTable = (payload) => {
  return axiosPost(`${API_ENDPOINTS.DATA_API}/user-tables`, payload);
};
export const addDatabaseItem = (tableName, payload) => {
  return axiosPost(
    `${API_ENDPOINTS.DATA_API}/user-tables/${tableName}/items`,
    payload
  );
};

export const addDatabaseItemByVersion = (
  tableName,
  payload,
  version = 'v8'
) => {
  return axiosPost(
    `${API_ENDPOINTS.DATA_API_BASE_URL}/${version}/user-tables/${tableName}/items`,
    payload
  );
};

export const deleteDatabaseItem = (tableName, id) => {
  return axiosDelete(
    `${API_ENDPOINTS.DATA_API_BASE_URL}/${getDataApiVersion(
      tableName
    )}/user-tables/${tableName}/items/${encodeURIComponent(id)}`
  );
};

export const updateDatabaseItem = (tableName, payload) => {
  return axiosPut(
    `${API_ENDPOINTS.DATA_API}/user-tables/${tableName}/items`,
    payload
  );
};

export const duplicateWorkflow = (workFlowId) => {
  return axiosPut(`${API_ENDPOINTS.DATA_API}/duplicate-flow/${workFlowId}`);
};

export const leaveWorkflow = (workFlowId) => {
  return axiosDelete(`${API_ENDPOINTS.DATA_API}/flow/iam/${workFlowId}`);
};
